// startup
// Load entry module and return exports
// This entry module used 'module' so it can't be inlined
var __webpack_exports__ = __webpack_require__("./node_modules/.pnpm/jquery@3.7.1/node_modules/jquery/src/jquery.js");
